import { __read } from "tslib";
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useWindowSizeHook } from '@mercell/use-window-resize-react-hook';
export var useScrollHeight = function (isExpanded) {
    var _a = __read(useState(0), 2), scrollHeight = _a[0], setScrollHeight = _a[1];
    var ref = useRef(null);
    var isExpandedRef = useRef(isExpanded);
    var width = useWindowSizeHook().width;
    useLayoutEffect(function () {
        if (isExpanded !== isExpandedRef.current) {
            isExpandedRef.current = isExpanded;
        }
    }, [isExpanded]);
    useLayoutEffect(function () {
        var _a;
        if (!isExpanded && scrollHeight === 'auto') {
            setScrollHeight(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0);
        }
    }, [scrollHeight, isExpanded]);
    useEffect(function () {
        var currentRef = ref.current;
        // Setup MutationObserver to observe changes to ref content and update the scrollHeight when changes are detected
        // eslint-disable-next-line no-undef
        var observer = new MutationObserver(function () {
            var observerNewValue = (currentRef === null || currentRef === void 0 ? void 0 : currentRef.scrollHeight) || 0;
            setScrollHeight(function (currentValue) {
                if (isExpandedRef.current != null && !isExpandedRef.current) {
                    return 0;
                }
                if (currentValue === 'auto') {
                    return currentValue;
                }
                return observerNewValue;
            });
        });
        var transitionEndAction = function (transitionEvent) {
            var element = transitionEvent.currentTarget;
            setScrollHeight(function (currentValue) {
                if (currentValue === (element === null || element === void 0 ? void 0 : element.scrollHeight) &&
                    isExpandedRef.current) {
                    return 'auto';
                }
                return currentValue;
            });
        };
        if (currentRef) {
            observer.observe(currentRef, {
                childList: true,
                subtree: true,
                characterDataOldValue: true,
                attributeOldValue: true,
            });
            currentRef.addEventListener('transitionend', transitionEndAction);
        }
        return function () {
            observer.disconnect();
            currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('transitionend', transitionEndAction);
        };
    }, [ref, width]);
    return { scrollHeight: scrollHeight, ref: ref };
};
export default useScrollHeight;
